import { render, staticRenderFns } from "./tloanapply-add-or-updateloan.vue?vue&type=template&id=058da7cc&scoped=true&"
import script from "./tloanapply-add-or-updateloan.vue?vue&type=script&lang=js&"
export * from "./tloanapply-add-or-updateloan.vue?vue&type=script&lang=js&"
import style0 from "./tloanapply-add-or-updateloan.vue?vue&type=style&index=0&id=058da7cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058da7cc",
  null
  
)

export default component.exports